import styled from 'styled-components'

export const ContentContainer = styled.section`
    max-width: ${props => props.theme.container.inner}px;
    width: 100%;
    display: flex;
    flex-direction: column;
`